module.exports = "http://localhost:4567/assets/fonts/f3454a3a78f16ac510c8ecce22b9a75d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-sass/assets/fonts/font-awesome/fontawesome-webfont.svg?v=4.7.0
// module id = 801
// module chunks = 4